/**
 * This file is to mapped all the routes define on each .js file
 * Import files in modules dir
 *
 * If you have a new file/routes just import here then register on the export
 */
import auth from '@/routes/modules/auth';
import starter from '@/routes/modules/starter';
import finance from '@/routes/modules/finance';
import ticket from '@/routes/modules/ticket';
import pagegroup from '@/routes/modules/pagegroup';
import customer from '@/routes/modules/customer';
import profit_centre from '@/routes/modules/profit_centre';
import error from '@/routes/modules/error';
import dashboard from '@/routes/modules/dashboard';
import item from '@/routes/modules/item';
import tax_group from '@/routes/modules/tax_group';
import tax_rate from '@/routes/modules/tax_rate';
import order from '@/routes/modules/order';
import account from '@/routes/modules/account';
import contact from '@/routes/modules/contact';
import user_profile from '@/routes/modules/user_profile';
import user from '@/routes/modules/user';
import portal from '@/routes/modules/portal';
import event_template from '@/routes/modules/event_template';
import time_tracking from "@/routes/modules/time_tracking";
import end_user_portal from "@/routes/modules/end_user_portal";
import event from "@/routes/modules/event";
import forgot_password from "@/routes/modules/forgot_password";
import services from "@/routes/modules/services";
import reports from "@/routes/modules/reports";
import invoice from "@/routes/modules/invoice";
import payment from "@/routes/modules/payment";
import payment_method from '@/routes/modules/payment_method';
import otp_verification from '@/routes/modules/otp-verification';
import account_receivables from '@/routes/modules/account_receivables';
import sp_payments from '@/routes/modules/sp_payments';
import modules_features from '@/routes/modules/modules_features';
import roles_permissions from '@/routes/modules/roles_permissions';
import profit_centre_setup from '@/routes/modules/profit_center_setup';
import ticket_setup from '@/routes/modules/ticket_setup';
import user_portal_users from '@/routes/modules/user_portal_users';
import sign_up from '@/modules/Signup/routes';
import core_events from '@/routes/modules/core_events';
import setup_events from '@/routes/modules/setup_events';

// Once imported using spread operator syntax, you can easily register the routes
export default [
    ...auth,
    ...starter,
    ...finance,
    ...ticket,
    ...pagegroup,
    ...customer,
    ...profit_centre,
    ...error,
    ...dashboard,
    ...item,
    ...tax_group,
    ...tax_rate,
    ...tax_rate,
    ...order,
    ...account,
    ...contact,
    ...portal,
    ...user_profile,
    ...user,
    ...event_template,
    ...time_tracking,
    ...end_user_portal,
    ...event,
    ...forgot_password,
    ...services,
    ...reports,
    ...invoice,
    ...payment,
    ...payment_method,
    ...otp_verification,
    ...account_receivables,
    ...sp_payments,
    ...modules_features,
    ...roles_permissions,
    ...profit_centre_setup,
    ...ticket_setup,
    ...user_portal_users,
    ...sign_up,
    ...core_events,
    ...setup_events,
    {
        path: '/:catchAll(.*)', // unrecognized path automatically redirect to error page
        redirect: '/not-found',
    },
];
